import {AbstractControl, AsyncValidatorFn, FormControl, ValidationErrors} from "@angular/forms";
import {Observable, of} from "rxjs";
import {catchError, finalize, map} from "rxjs/operators";
import {EventEmitter, Injectable} from "@angular/core";
import {EndpointsProvider} from "../endpoints/endpoint-provider.service";

@Injectable()
export class AccountExistsValidatorFactory {

	private static readonly _validationFinished$: EventEmitter<any> = new EventEmitter();

	constructor(private endpoints: EndpointsProvider) {
	}

	static validationFinished$(): Observable<any> {
		return AccountExistsValidatorFactory._validationFinished$.asObservable();
	}

	create(emailToExcludeFromAccountValidation: string | null): AsyncValidatorFn {
		return (control: AbstractControl) => {
			const email = control.value;
			if (!!emailToExcludeFromAccountValidation && email == emailToExcludeFromAccountValidation) {
				return of(null) as Observable<ValidationErrors | null>;
			}

			return this.endpoints.user.checkAccountExists(control.value).pipe(
				map(accountExists => {
					return accountExists == "true" ?
						{accountexists: 'Account already exists'} as ValidationErrors :
						null;
				}),
				catchError(error => of(null)),
				finalize(() => AccountExistsValidatorFactory._validationFinished$.emit())
			) as Observable<ValidationErrors | null>;
		}
	}
}
